/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Container from "./pages";
import Profile from "./pages/profile";
import MyProfile from "./pages/myprofile";
import Notify from "pages/notify";
import Birthday from "./pages/birthday";

import API from "./utils/API";
import Func from "./utils/Func";

import PreviewLoginInput from "./PreviewLoginInput";
import { useAuth } from "./context/AuthContext";
window.$google_email = "";
window.$user_profile = {};

const VirtualPath = () => {
  const {
    googleProfile,
    setGoogleProfile,
    userProfile,
    setUserProfile,
    checkIsAdminPreview,
    isEmergencyMaintenance,
  } = useAuth();

  const handlePreview = (val) => {
    const nextEmail = String(val || "").trim();
    if (!nextEmail || !nextEmail.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }

    if (checkIsAdminPreview()) {
      if (nextEmail === googleProfile?.email) {
        return;
      }
      setUserProfile({});
      setGoogleProfile((prev) => ({
        ...prev,
        email: nextEmail,
        keyChange: (prev?.keyChange || 0) + 1,
      }));
    }
  };

  const handleReset = () => {
    if (checkIsAdminPreview()) {
      const nextEmail = String(googleProfile?.authEmail || "").trim();
      if (!nextEmail || nextEmail === googleProfile?.email) {
        return;
      }
      setUserProfile({});
      setGoogleProfile((prev) => ({
        ...prev,
        email: nextEmail,
        keyChange: (prev?.keyChange || 0) + 1,
      }));
    }
  };

  useEffect(() => {
    if (googleProfile?.email !== "") {
      const mainFunc = async () =>
        await API.post("user", {
          params: {
            email: googleProfile.email,
            path: window.location.pathname,
          },
        });
      mainFunc()
        .then((res) => {
          const decrypt = res?.data;
          if (decrypt?.status === "success" && decrypt?.data) {
            setUserProfile(decrypt.data);
          } else {
            setUserProfile({
              err: 1,
              err_msg: `Failes : Not found this email (${googleProfile.email})`,
            });
          }
        })
        .catch((err) => {
          setUserProfile({ err: 1, err_msg: `Failes : ${err}` });
        });
    }
  }, [googleProfile?.email]);

  if (isEmergencyMaintenance) {
    return VirtualPathFunc.HtmlEmergencyMaintenance();
  }

  if (googleProfile?.email === "" && googleProfile?.err === 0) {
    return VirtualPathFunc.HtmlPageLoading();
  }
  if (googleProfile?.err === 1) {
    return VirtualPathFunc.HtmlPageError(googleProfile.err_msg);
  }
  if (userProfile?.err && userProfile?.err === 1) {
    return VirtualPathFunc.HtmlPageError(userProfile.err_msg);
  }
  window.$google_email = googleProfile.email;
  if (!Func.IsEmptyObject(userProfile)) {
    window.$user_profile = userProfile;
    if (
      !googleProfile?.isAdmin &&
      process.env.REACT_APP_SYSTEM_CLOSED === "true"
    ) {
      return (
        <div id="container" className="container" style={{ width: "99%" }}>
          <div
            style={{
              textAlign: "center",
              fontSize: "2rem",
              color: "#333",
              marginTop: "0%",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <p>
              We regret to inform you that our system is temporarily
              unavailable.
            </p>
            <p>
              We will resume operations on <strong>Monday</strong>.
            </p>
            <p>
              We apologize for any inconvenience and appreciate your
              understanding.
            </p>
          </div>
        </div>
      );
    }
    return (
      <div key={"router-content-" + googleProfile.keyChange}>
        {checkIsAdminPreview() && (
          <PreviewLoginInput
            defaultValue={googleProfile.email}
            onApply={handlePreview}
            onReset={handleReset}
            label="Preview Login as:"
            placeholder="Enter user email"
            buttonText="Apply"
          />
        )}
        <Router>
          <Switch>
            <Route path="/employees/notification" component={Notify} />
            <Route path="/employees/profile" component={Profile} />
            <Route path="/employees/myprofile" component={MyProfile} />
            <Route path="/employees/birthday" component={Birthday} />
            <Route
              exact
              path={["/employees", "/employees/"]}
              component={Container}
            />
          </Switch>
        </Router>
      </div>
    );
  }
  return VirtualPathFunc.HtmlPageLoading();
};
const VirtualPathFunc = {
  HtmlEmergencyMaintenance() {
    return (
      <div
        id="container"
        className="container"
        style={{
          width: "100%",
          minHeight: "100vh",
          margin: 0,
          backgroundColor: "#f4f6f5",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          padding: "80px 24px 24px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "760px",
            backgroundColor: "#ffffff",
            border: "1px solid #d9dfdc",
            borderRadius: "10px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
            padding: "40px 32px",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            color: "#4d5752",
            lineHeight: "1.7",
          }}
        >
            <h1
              style={{
                margin: "0 0 16px",
                color: "#2f6f4f",
                fontSize: "2rem",
                fontWeight: 700,
              }}
            >
            Server Under Emergency Maintenance
            </h1>
            <p style={{ margin: "0 0 8px", fontSize: "1.05rem" }}>
              We are currently performing emergency maintenance to resolve a
              critical issue.
            </p>
            <p style={{ margin: "0 0 8px", fontSize: "1.05rem" }}>
              Our team is working hard to restore normal service as quickly as
              possible.
            </p>
            <p style={{ margin: "0 0 8px", color: "#6a7570" }}>
              Please check back shortly.
            </p>
            <p style={{ margin: 0, color: "#6a7570" }}>
              Thank you for your patience and understanding.
            </p>
            <p
              style={{
                margin: "14px 0 0",
                color: "#6a7570",
                fontSize: "0.98rem",
              }}
            >
              For urgent issues, please contact Nattanan Seeruang or submit a
              support ticket.
            </p>
        </div>
      </div>
    );
  },
  HtmlPageError(err_msg) {
    const message = String(err_msg || "Unknown error");
    const isPopupBlocked = /blocked google login popup|allow popups/i.test(
      message,
    );

    let html = (
      <div className="auth-error-shell">
        <div className="auth-error-card">
          <div className="auth-error-badge">Sign-in Required</div>
          <h4 className="auth-error-title">
            {isPopupBlocked ? "Popup blocked by browser" : "Unable to continue"}
          </h4>
          <p className="auth-error-message">{message}</p>
          {isPopupBlocked && (
            <ol className="auth-error-steps">
              <li>Allow popups for this site in your browser settings.</li>
              <li>Refresh this page and try sign-in again.</li>
            </ol>
          )}
          <div className="auth-error-actions">
            <button
              type="button"
              className="auth-error-btn"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
          </div>
        </div>
      </div>
    );
    return html;
  },
  HtmlPageLoading() {
    let html = (
      <div className="container">
        <div className="auth-loading-shell">
          <div className="auth-loading-card">
            <div className="auth-loading-spinner" aria-hidden="true"></div>
            <div className="auth-loading-title">Loading...</div>
            <div className="auth-loading-subtitle">Checking your session</div>
          </div>
        </div>
      </div>
    );
    return html;
  },
  GetUserData(email) {
    const [userProfile, setUserProfile] = useState({});
    useEffect(() => {
      const mainFunc = async () =>
        await API.post("user", {
          params: {
            email: email,
            path: window.location.pathname,
          },
        });
      mainFunc()
        .then((res) => {
          const decrypt = res?.data;
          if (decrypt?.status === "success" && decrypt?.data) {
            setUserProfile(decrypt.data);
          } else {
            setUserProfile({
              err: 1,
              err_msg: `Failes : Not found this email (${email})`,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          setUserProfile({ err: 1, err_msg: `Failes : ${err}` });
        });
    }, [email]);
    return userProfile;
  },
};
export { VirtualPath, VirtualPathFunc };
